import React, { useEffect, useRef, useState } from "react";
import api from "./api";
import ChatConnection from "./ChatConnection";
import ChatPage from "./components/ChatPage";
import LoadingScreen from "./components/LoadingScreen";
import OffllineMessage from "./components/OfflineMessage";
import { ChatEvents, MessageType, Product, Roles, WebCalling } from "./constants";
import { isTokenExpired, generateMessageId } from "./utils";
import ContactSupport from "./components/ContactSupportPage";
import HomeDashboard from "./components/Home/HomePage";
import HomePage from "./components/HomePage";
import CarRegNumberPage from "./components/CarRegisterationNoPage";
import PbWebChat from "./components/PbWebChat";

function App({ room, setRoom, user, setUser, URLData }) {
  const connectionConCount = useRef(0);
  const [initialized, setInitialized] = useState(false);
  const [connected, setConnected] = useState(false);
  const [registered, setRegistered] = useState(false);
  const [messageBuffer, setMessageBuffer] = useState({});
  const [tabHasFocus, setTabHasFocus] = useState(false);
  const [messageCounter, setMessageCounter] = useState([])
  const [planComparison, setPlanComaprisonDetails] = useState(null)
  const [planFeatures, setPlanFeatures] = useState(null)
  const [selectedRoom, setSelectedRoom] = useState(null)
  const [isOffline, setIsOffline] = useState(false)
  const [OfflineMessage, setOfflineMsg] = useState(null)
  const [styleInit, setStyleInit] = useState(false)
  const [contactSupport, setContactSupport] = useState(false)
  const [isService, setService] = useState(false)
  const [OPTVerified, setVerifyied] = useState(false)
  const [productId, selectProductId] = useState(null)
  const [isSales, setSales] = useState(false)
  const [inputType, setInputType] = useState({ displayValue: "Policy No.", value: "policyNo" })
  const [lastHistoryMsg, setLastHistoryMsg] = useState(false)
  const [showHistory, setShowHistory] = useState(false)
  const [haveExistingChat, setHaveExistingChat] = useState(false)
  const [isOfflineWorkingHour, setIsOfflineWorkingHour] = useState(false);
  const [offWorkingHourMsg, setOffWorkingHourMsg] = useState("");
  const [askForRating, setAskForRating] = useState(null);
  const [askForRatingTicket, setAskForRatingTicket] = useState(null);
  const [isIframeOpen, setIsIframeOpen] = useState(false);

  const [maskedMobileNo, setMaskedMobileNo] = useState(null)
  const [verifyOTP, setVerifyOTP] = useState(false)
  const [loader, setLoader] = useState(false)
  const [showCarRegNoPage, setShowCarRegNoPage] = useState(false)
  const [skipVerifyingCarReg, setSkipVerifyingCarReg] = useState(false)
  const [carRegNo, setCarRegNo] = useState(null)
  const [carNoValid, setCarNoValid] = useState(false)
  const chatDivRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [newTermUi,setNewTermUi] = useState(false);
  const webCallIdRef = useRef(null);
  const [webCallingEnable, setWebCallingEnable] = useState(false);
  const [hideTicketCsat, setHideTicketCsat] = useState(false);
  const [ticketRatingDone, setTicketRatingDone] = useState(false);
  const [ticketInactivityClosed, setTicketInactivityClosed] = useState(false);
  const [agentMsgReplied, setAgentMsgReplied] = useState(null);

  const [maxUploadFileSize, setMaxUploadFileSize] = useState(0);
  const checkIfHealthMobileView = () => {
    return (URLData['m'] === '1')
  };

  const [homeChat,setHomeChat] = useState(false);
  // console.log('chatDivRef',chatDivRef.current?.clientHeight)

  useEffect(() => {
    if (initialized) {
      if (room && selectedRoom && room[selectedRoom] && room[selectedRoom].productId && room[selectedRoom].productId === Product.Health && !room[selectedRoom].isService) {
        import('./styles-health.css').then((res) => { setStyleInit(true) })
        // setStyleInit(true)
      }
      else if (room && selectedRoom && room[selectedRoom] && room[selectedRoom].productId && room[selectedRoom].productId === Product.Travel && !room[selectedRoom].isService) {
        import('./styles-Travel.css').then((res) => { setStyleInit(true) })
        // setStyleInit(true)
      }
      else if (room && selectedRoom && room[selectedRoom] && room[selectedRoom].productId && room[selectedRoom].productId === Product.Investment  && !room[selectedRoom].isService) {
        //import('./styles-investment.css').then((res) => { setStyleInit(true) })
        // setStyleInit(true)
        import('./styles-investment-v1.css').then((res) => { setStyleInit(true) })
      }
      else if (room && selectedRoom && room[selectedRoom] && room[selectedRoom].productId && room[selectedRoom].productId === Product.Home && !room[selectedRoom].isService) {
        import('./styles-Home.css').then((res) => { setStyleInit(true) })
        // setStyleInit(true)
      }
      else if (room && !newTermUi  && selectedRoom && room[selectedRoom] && room[selectedRoom].productId && room[selectedRoom].productId === Product.Term && !room[selectedRoom].isService) {
        import('./styles-term.css').then((res) => { setStyleInit(true) })
        // setStyleInit(true)
      }
      else if (room && newTermUi  && selectedRoom && room[selectedRoom] && room[selectedRoom].productId && room[selectedRoom].productId === Product.Term && !room[selectedRoom].isService) {
        import('./styles-term-v1.css').then((res) => { setStyleInit(true) })
        // setStyleInit(true)
      }
      else if (room && selectedRoom && room[selectedRoom] && room[selectedRoom].productId && room[selectedRoom].productId === Product.Twowheeler  && !room[selectedRoom].isService) {
        import('./styles-Twowheeler.css').then((res) => { setStyleInit(true) })
        // setStyleInit(true)
      }
      else {
        import('./contactus.css').then((res) => { setStyleInit(true) })
        // setTimeout(() => {
        //   setStyleInit(true)
        // }, 500)

      }
      // else {
      //   // setStyleInit(true)
      // }
    }
  }, [initialized])

  // useEffect(() => {
  //   if (chatDivRef.current?.clientHeight) {
  //     setTabHasFocus(true);
  //   }
  // }, [chatDivRef.current?.clientHeight]);

  useEffect(() => {
    if (isIframeOpen) {
      console.log("isIframeOpen::: ",isIframeOpen)
      setTabHasFocus(true);
    }else{
      console.log("isIframeOpen::: ",isIframeOpen)
      setTabHasFocus(false);
    }
  }, [isIframeOpen]);
  useEffect(() => {
    const handleFocus = () => {
      if (isIframeOpen) {
        console.log("handleFocus::: ")
        setTabHasFocus(true);
      }
    };

    const handleBlur = () => {
      setTabHasFocus(false);
    };

    const processPostMessages = (e) => {
      if (e.data && e.data?.message == 'chat-box-state') {
        console.log(e.data)
        setIsIframeOpen(e.data?.value);
      }
    };

    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);
    window.addEventListener('message', processPostMessages)
    return () => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
      window.removeEventListener('message', processPostMessages)
    };
  }, []);



  const roomJoined = room && room.joined ? room.joined : false;
  useEffect(async () => {
    if (room && selectedRoom && room[selectedRoom] && room[selectedRoom].isService) {
      let resp = await api.getChatHistory(room[selectedRoom].token, null)
      if (resp && resp.code === 200) {
        // addHistoryMessages(resp.result.messages)
        setShowHistory(resp.result.showHistory)
      }
    }
  }, [initialized, selectedRoom])

  const checkForMobileDevice = async () => {
    let isMobile = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      isMobile = true;
    }
    return isMobile;
  }

  useEffect(() => {
    console.log("Initialize called");
    if (!initialized) {
      let usr = user;
      let rm = room;
      console.log(room)
      const init = async () => {
        if (usr && isTokenExpired(usr.token)) {
          usr = null;
        }
        if (!usr) {
          rm = null;
          usr = await api.createUser(URLData.params);
          if (usr) {
            setUser(usr);
            console.log("New User initialized");
            //TODO What if room token is not expired??
          } else {
            return;
          }
        }
        if (rm) {
          for (let roomdetails of Object.values(rm)) {

            if ((roomdetails && roomdetails.token && isTokenExpired(roomdetails.token)) || !roomdetails.isOpen) {
              delete rm[roomdetails.roomId];
            }
          }
        } 
        let isMobile = await checkForMobileDevice();
        // debugger
        let data = await api.createRoom({
          userToken: usr.token,
          url: URLData.params,
          isService: isService,
          productId: productId,
          policyDetail: inputType,
          skipVerifyingCarReg : skipVerifyingCarReg,
          isMobile: isMobile
        });
        if(data.maxUploadFileSize){
          setMaxUploadFileSize(parseInt(data.maxUploadFileSize))
        }
        if (data.webCallingEnable) {
          setWebCallingEnable(true);
        }
        if (data.isOffline) {
          setIsOffline(true)
          setOfflineMsg(data.offlineMsg)
          setTimeout(() => {
            window.parent.postMessage({ message: 'Chat Initiate Failed', chatInitiateFailed: true, minimize: true, closeChat: true }, '*');
          }, 2500);
        }
        else if (data.askForCarRegNo) {
          setShowCarRegNoPage(data.askForCarRegNo)
          setVerifyied(data.OPTVerified)
          setSales(true)
        }
        else if (data.isHome){
          setHomeChat(true)
        }
        else if (data.contactSupport) {

          setContactSupport(data.contactSupport)
          setVerifyied(data.OPTVerified)
          if (data.registrationNo) {
            setInputType({ displayValue: "Registration No.", value: "registrationNo", key: data.registrationNo })
            setVerifyOTP(data.otpSend)
            setMaskedMobileNo(data.maskedMobileNo)
            setService(true)
          }

        }
        else if (data) {
          let roomData = data.roomData;
          let roomToken = data.roomToken
          setSelectedRoom(roomData.roomId)
          setHaveExistingChat(data.haveExistingChat)
          let messagesMap = {};

          if (data && data.messages && data.messages[roomData.roomId]) {

            for (const message of data.messages[roomData.roomId]) {
              messagesMap[message._id] = {
                messageId: message._id,
                content: message.content,
                from: message.from,
                roomId: message.roomId,
                sentAt: message.sentAt,
                type: message.type || MessageType.Text,
                selected: message.selected || null,
                role: message.role || null,
                receivedAt: message.receivedAt || null,
                deliveredAt: message.deliveredAt || null,
                readAt: message.readAt || null,
                employeeId: message.employeeId,
                name: message.name
              };
            }
            let unreadMsgs = data.messages[roomData.roomId].filter((msg) => !msg.readAt && msg.role === Roles.Agent);
            console.log('unreadMsgs',unreadMsgs.length)
            setMessageCounter(unreadMsgs)
          }

          if (roomData.agent && roomData.agent.name) {
            // Add agent assigned alert
            window.parent.postMessage({ message: 'Agent connected.', roomId: roomData.roomId, name: roomData.agent.name, employeeId: roomData.agent?.employeeId || "" }, '*');
            if (roomData.isHomePagechat || (roomData.transferredFrom?.depName !== "TermLife" && roomData.transferredFrom?.depName !== "Investments" && roomData.transferredFrom?.depName !== "Investments_Nri") && (roomData.department?.depName !== "TermLife" && roomData.department?.depName !== "Investments" && roomData.department?.depName !== "Investments_Nri")) {
              let alert = {
                messageId: generateMessageId(),
                alert: `You are now connected with ${roomData.agent.name} (${roomData.agent.employeeId})`,
                type: "alert",
                from: "system",
                sentAt: roomData.assignedAt,
              };
              if (roomData.roomTransfer && (roomData.transferredFrom?.depName === "Health" || roomData.transferredFrom?.depName === "Health_NRI") && roomData.productId === Product.Health) {
                alert["alert"] = `You have now been connected to a new advisor, ${roomData.agent.name} (${roomData.agent.employeeId}), to assist you better.`;
              }
              messagesMap[alert.messageId] = alert;
            }
          }
          console.log(rm)
          setRoom({
            ...rm,
            ...{
              [roomData.roomId]: {
                // ...rm[roomData.roomId],
                ...roomData,
                ...{
                  messages: { ...messagesMap },
                  token: roomToken,
                },
              },
            },
          });
          console.log("New Room initialized");
          let chatIntent = "";
          if (roomData.isService) {
            chatIntent = roomData.productName + "_service";
          } else {
            chatIntent = roomData.productName + "_sales";
          }          
          GAEvent({
            eventAction: "chatInit", eventLabel: "Room created",
            custId: roomData.customerId, leadId: roomData.leadId, deptName: roomData.department.depName,
            chatMedium: roomData.chatMedium, roomId: roomData.roomId,
            source: roomData.source, chatintent: chatIntent
          })        
          setContactSupport(false)

          if (data.isOfflineWorkingHour && data.offWorkingHourMsg) {
            setIsOfflineWorkingHour(true);
            setOffWorkingHourMsg(data.offWorkingHourMsg);
          }

          if(data.roomData.newTermUi){
            setNewTermUi(true);
          }
        }
        setInitialized(true);
        console.log("Initialization complete");
        window.parent.postMessage({ message: 'Popup Ready.' }, '*');
      };
      init();
    }
  }, [initialized]);

  useEffect(() => {
    if (registered && selectedRoom) {
      setMessageBuffer({
        ...messageBuffer,
        ...{
          [generateMessageId()]: {
            action: ChatEvents.JoinRoomRequested,
            auth: room[selectedRoom].token,
          },
          [generateMessageId()]: {
            action: ChatEvents.RequestBot,
            auth: room[selectedRoom].token,
          },
        },
      });
    }
  }, [registered]);
  // useEffect(() => {
  //   // Setup a ping to server
  //   if (connected && selectedRoom && room[selectedRoom].isOpen) {

  //     // clearInterval(pingMonitor.current);


  //     setInterval(function () {
  //       //console.log("sending ping");

  //       setMessageBuffer({
  //         ...messageBuffer,
  //         ...{
  //           [generateMessageId()]: {
  //             action: ChatEvents.Ping,
  //             auth: room[selectedRoom].token,
  //             sentAt: new Date().toISOString()
  //           },
  //         },
  //       });
  //     }, 5000);
  //   }
  // }, [connected]);
  useEffect(() => {
    let pingInterval;
    
    if (connected && selectedRoom && room[selectedRoom]?.isOpen) {
      pingInterval = setInterval(function () {
        try {
          setMessageBuffer(prevBuffer => ({
            ...prevBuffer,
            [generateMessageId()]: {
              action: ChatEvents.Ping,
              auth: room[selectedRoom].token,
              sentAt: new Date().toISOString()
            }
          }));
        } catch (error) {
          console.error("Error sending ping:");
        }
      }, 5000);
    }
    
    // Clean up the interval when the component unmounts or dependencies change
    return () => {
      if (pingInterval) {
        clearInterval(pingInterval);
      }
    };
  }, [connected]);

  const prevJoinedRef = useRef(false);

  useEffect(() => {
    try {
      if (room) {
        if (initialized && room?.joined && room.joined !== prevJoinedRef.current && connectionConCount.current > 1) {
          refreshRoom();
        }
        prevJoinedRef.current = room.joined;
      }
    } catch (e) {
      console.error("Error in joined useEffect");
    }
  }, [room]);  

  const refreshRoom = async () => {
    try{
      let data = await api.getRoomData(room[selectedRoom].token);
      if(data && data.messages && data.messages[selectedRoom] && Array.isArray(data.messages[selectedRoom]) ){
        let messagesMap = {};
        for (const message of data.messages[selectedRoom]) {
          messagesMap[message._id] = {
            messageId: message._id,
            content: message.content,
            from: message.from,
            roomId: message.roomId,
            sentAt: message.sentAt,
            type: message.type || MessageType.Text,
            selected: message.selected || null,
            role: message.role || null,
            receivedAt: message.receivedAt || null,
            deliveredAt: message.deliveredAt || null,
            readAt: message.readAt || null,
            employeeId: message.employeeId,
            name: message.name
          };
        }
        setRoom({
          ...room,
          ...{
            [selectedRoom]: {
              ...room[selectedRoom],
              ...{
                messages: { ...messagesMap },
              },
            },
          },
    
        });
      }
    }catch(e){
      console.log('rr error',e.message);
    }
  };


  // useEffect(() => {
  //   if (roomJoined && room[selectedRoom]) {
  //     console.log("Room Joined");
  //     setMessageBuffer({
  //       ...messageBuffer,
  //       ...{
  //         [generateMessageId()]: {
  //           action: ChatEvents.RequestBot,
  //           auth: room[selectedRoom].token,
  //         },
  //       },
  //     });

  //     // This would happen every time user joins the room even if on reconnect
  //     // console.log("Refreshing room state");
  //   }
  //   // refreshRoom();

  // }, [roomJoined]);

  useEffect(() => {
    if (connected) {
      console.log("Socket Connected");
      setMessageBuffer({
        ...messageBuffer,
        ...{
          [generateMessageId()]: {
            action: ChatEvents.Register,
            auth: user.token,
          },
        },
      });
      connectionConCount.current = connectionConCount.current +1;
    } else {
      // When Socket disconnects reset registration and room state to that on reconnect whole flow runs correctly
      setRoom((room) => ({ ...room, ...{ joined: false } }));
      setRegistered(false);
    }
  }, [connected]);

  const onJoinRoom = () => {
    setRoom({ ...room, ...{ joined: true } });
  };

  useEffect(() => {
    if (tabHasFocus && isIframeOpen) {
      for (let message of messageCounter) {
        console.log("sending reads")
        sendReadReceipt(message)
      }
      setMessageCounter([])
    }
  }, [tabHasFocus])
  useEffect(() => {
    if (messageCounter) {
      window.parent.postMessage({ message: 'Unread messages.', unreadMessages: messageCounter.length }, '*');
      // window.parent.postMessage({ message: 'New messages.', source: 'chat', newMessage: true }, '*');
    }
  }, [messageCounter])
  const setCounter = (message) => {
    if (message.from !== user.id && !tabHasFocus) {
      setMessageCounter((messages) => [...messages, message])
    } else {
      console.log("sending reads from here:::");
      sendReadReceipt(message)
    }
  }
  const getHistoryMessages = async (token, letLastmagTimeStamp) => {
    let resp = await api.getChatHistory(token, letLastmagTimeStamp)
    if (resp && resp?.result?.messages && resp?.result?.messages.length) {
      addHistoryMessages(resp.result.messages)
      setLastHistoryMsg(resp.result.conversation_end)
    }
  }
  const addHistoryMessages = (messages) => {
    for (let msg of messages) {


      setRoom((room) => ({
        ...room,
        ...{
          [selectedRoom]: {
            ...room[selectedRoom],
            ...{
              oldMessages: {
                ...room[selectedRoom].oldMessages,
                ...{
                  [msg.messageId || msg._id]: {
                    ...{
                      messageId: msg.messageId || msg._id,
                      content: msg.content,
                      from: msg.from,
                      roomId: msg.roomId,
                      sentAt: msg.sentAt,
                      type: msg.type || MessageType.Text,
                      role: msg.role || null,
                      employeeId: msg.employeeId || null,
                      name: msg.name || null,
                    },
                  },
                },
              },
            },
          },
        },
      }));
    }
  }
  const onMessage = (message) => {
    if (message.role === "agent" || message.role === "bot") {
      let productId = room && room[message.roomId] && room[message.roomId].productId ? room[message.roomId].productId : 0
      window.parent.postMessage({ message: 'New messages.', source: 'chat', newMessage: true, productId: productId }, '*');
    }
    if (message.roomId == selectedRoom) {
      setRoom((room) => ({
        ...room,
        ...{
          [selectedRoom]: {
            ...room[selectedRoom],
            ...{
              messages: {
                ...room[selectedRoom].messages,
                ...{
                  [message.messageId || message._id]: {
                    ...{
                      messageId: message.messageId || message._id,
                      content: message.content,
                      from: message.from,
                      roomId: message.roomId,
                      sentAt: message.sentAt,
                      type: message.type || MessageType.Text,
                      role: message.role || null,
                      employeeId: message.employeeId || null,
                      name: message.name || null,
                    },
                  },
                },
              },
            },
          },
        },
      }));
      setCounter(message)
      sendDeliveryReceipt(message)
    }
    if (message && message.gaTag) {
      GAEvent({ eventAction: message.gaTag, eventLabel: message.messageId })
    }
  };

  const onReceiveReceipt = (message) => {
    if (message.roomId == selectedRoom) {
      let existing = room[selectedRoom].messages[message.messageId];
      if (!existing) {
        existing = {};
      }
      setRoom({
        ...room,
        ...{
          [selectedRoom]: {
            ...room[selectedRoom],
            ...{
              messages: {
                ...room[selectedRoom].messages,
                ...{
                  [message.messageId]: {
                    ...existing,
                    receivedAt: message.receivedAt,
                  },
                },
              },
            }
          }
        },
      });
    }
  };
  const onReadReceipt = (message) => {
    if (message.roomId == selectedRoom) {
      let existing = room[selectedRoom].messages[message.messageId];
      if (!existing) {
        existing = {};
      }
      setRoom({
        ...room,
        ...{
          [selectedRoom]: {
            ...room[selectedRoom],
            ...{
              messages: {
                ...room[selectedRoom].messages,
                ...{
                  [message.messageId]: {
                    ...existing,
                    readAt: message.readAt,
                  },
                },
              },
            }
          }
        },
      });
    }
  };

  const onDeliveryReceipt = (message) => {
    if (message.roomId == selectedRoom) {
      let existing = room[selectedRoom].messages[message.messageId];
      if (!existing) {
        existing = {};
      }
      setRoom({
        ...room,
        ...{
          [selectedRoom]: {
            ...room[selectedRoom],
            ...{
              messages: {
                ...room[selectedRoom].messages,
                ...{
                  [message.messageId]: {
                    ...existing,
                    deliveredAt: message.deliveredAt,
                  },
                },
              },
            }
          }
        },
      });
    }
  };

  const sendEvent = (event) => {
    setMessageBuffer((mb) => ({
      ...mb,
      ...{
        [generateMessageId()]: {
          ...event,
          ...{ auth: user.token },
        },
      },
    }));
  };

  const sendMessage = (Message) => {
    // remove auth from here
    let message = {
      messageId: Message.id || generateMessageId(),
      content: Message.content,
      roomId: selectedRoom,
      from: user.id,
      sentAt: new Date().toISOString(),
      type: Message.type || MessageType.Text,
      refMessageId: Message.refMessageId || null,
      docId: Message.docId || null,
      role: Roles.Customer,
    };

    let change = { [message.messageId]: message };
    if (Message.refMessageId) {
      // Assuming whenever refMessageId is set we have to set selected true
      change[Message.refMessageId] = {
        ...room[selectedRoom].messages[Message.refMessageId],
        ...{ selected: true },
      };
    }
    setRoom({
      ...room,
      ...{
        [selectedRoom]: {
          ...room[selectedRoom],
          ...{
            messages: {
              ...room[selectedRoom].messages,
              ...change,
            },
          },
        },
      },
    });
    setMessageBuffer((mb) => ({
      ...mb,
      ...{
        [message.messageId]: {
          ...{
            messageId: message.messageId,
            action: ChatEvents.Message,
            content: message.content,
            sentAt: message.sentAt,
            type: message.type,
            from: user.id,
            refMessageId: message.refMessageId || null,
            docId: message.docId || null,
          },
          ...{ auth: room[selectedRoom].token },
        },
      },
    }));

    try{
      const customerMessages = Object.values(room[selectedRoom]?.messages || {}).filter(
        (msg) => msg.role === Roles.Customer
      );
      if (customerMessages.length === 0 && !room[selectedRoom].agent.name) {
        let content = '';
        if (Message.type === MessageType.json) {
          let newContent = JSON.parse(Message.content);
          if (newContent && newContent.type === MessageType.document) {
            content = 'Document';
          } else {
            content = newContent.display_value || newContent.title;
          }
        } else {
          content = Message.content;
        }
        window.parent.postMessage({ message: 'Customer first message.', source: 'chat', firstMessage: true, content: content }, '*');
      };
    }catch(e){
      
    }

  };

  const sendDeliveryReceipt = (message) => {
    if (message.role != Roles.Customer) {
      let acknowlegement = {
        messageId: message.messageId,
        action: ChatEvents.MessageDelivered,
        readAt: new Date().toISOString(),
      };
      setMessageBuffer((mb) => ({
        ...mb,
        ...{
          [generateMessageId()]: {
            ...{ ...acknowlegement },
            ...{ auth: room[selectedRoom].token },
          },
        },
      }));
      // state.messageBuffer.push(acknowlegement);
    }
  }

  const sendReadReceipt = (message) => {
    if (message.role != Roles.Customer) {
      let acknowlegement = {
        messageId: message.messageId,
        action: ChatEvents.MessageRead,
        readAt: new Date().toISOString(),
      };
      setMessageBuffer((mb) => ({
        ...mb,
        ...{
          [generateMessageId()]: {
            ...{ ...acknowlegement },
            ...{ auth: room[selectedRoom].token },
          },
        },
      }));
      // state.messageBuffer.push(acknowlegement);
    }
  }

  const AssignmentRequested = (message) => {

    // let alert = {
    //   messageId: message.action,
    //   alert: `Please wait while we connect you to an advisor`,
    //   type: "alert",
    //   from: "system",
    //   sentAt: new Date().toISOString(),
    // };

    // setRoom({
    //   ...room,
    //   ...{
    //     [selectedRoom]: {
    //       ...room[selectedRoom],
    //       ...{
    //         messages: {
    //           ...room[selectedRoom].messages,
    //           ...{ [alert.messageId]: alert },
    //         },
    //       },
    //     },
    //   },
    // });
  }

  const deleteAssignmentRequestedMessage = () => {
    let msg = room[selectedRoom].messages
    delete msg[ChatEvents.QueuedForAssignment]
    setRoom({
      ...room,
      ...{
        [selectedRoom]: {
          ...room[selectedRoom],
          ...{
            messages: {
              msg
            },
          },
        },
      },

    });
  }
  const onAssignAgent = (message) => {

    if (message.roomId === selectedRoom) {
      deleteAssignmentRequestedMessage()
      let content = JSON.parse(message.content);
      let alertMessage = {
        messageId: generateMessageId(),
        alert: `You are now connected with ${content.name} (${content.employeeId})`,
        type: "alert",
        from: "system",
        sentAt: new Date(content.sentAt).toISOString(),
      };

      if (content.roomTransfer && (content.transferredFrom?.depName === "Health" || content.transferredFrom?.depName === "Health_NRI") && room[selectedRoom]?.productId === Product.Health) {
        alertMessage["alert"] = `You have now been connected to a new advisor, ${content.name} (${content.employeeId}), to assist you better.`
      }

      if (content.isHomePagechat || (content.transferredFrom?.depName !== "TermLife" && content.transferredFrom?.depName !== "Investments" && content.transferredFrom?.depName !== "Investments_Nri") && (content.departmentName !== "TermLife" && content.departmentName !== "Investments" && content.departmentName !== "Investments_Nri")) {


        setRoom({

          ...room,
          ...{
            [selectedRoom]: {
              ...room[selectedRoom],
              ...{
                agent: { name: content.name, employeeId: content.employeeId },
              },
              ...{
                messages: {
                  ...room[selectedRoom].messages,
                  ...{ [alertMessage.messageId]: alertMessage },
                },
              },
            },
          },
        });
      } else {
        setRoom({

          ...room,
          ...{
            [selectedRoom]: {
              ...room[selectedRoom],
              ...{
                agent: { name: content.name, employeeId: content.employeeId },
              }
            },
          },
        });
      }
      //send post message 
      window.parent.postMessage({ message: 'Agent connected.', source: 'chat', roomId: message.roomId, name: content.name, employeeId: content.employeeId }, '*');
    }
  };
  const uploadFile = async (files) => {
    for (let file of files) {
      let formData = new FormData();
      console.log(file.size / (1024 * 1024));
      if ((file.size / (1024 * 1024)) > maxUploadFileSize) {
        let alert = {
          messageId: generateMessageId(),
          content: `Maximum document size allowed is ${maxUploadFileSize}MB, Please try again.`,
          type: "text",
          from: "system",
          sentAt: new Date().toISOString(),
        };

        setRoom({
          ...room,
          ...{
            [selectedRoom]: {
              ...room[selectedRoom],
              ...{
                messages: {
                  ...room[selectedRoom].messages,
                  ...{ [alert.messageId]: alert },
                },
              },
            },
          },
        });
        return null
      }
      // formData.append('roomToken',room.token);
      setLoader(true)
      formData.append("file", file, file.name);
      let docUploadRes = await api.uploadCustomerDocument(formData, room[selectedRoom].token);
      setLoader(false)
      if (docUploadRes && docUploadRes.result && docUploadRes.result.docId) {
        let docMessageObject = {
          content: JSON.stringify({
            type: MessageType.document,
            document: { docId: docUploadRes.result.docId },
          }),
          docId: docUploadRes.result.docId,
          type: "json",
        };
        console.log("docUploadres---", docUploadRes.result);
        // send(docUploadRes.result) ;
        sendMessage(docMessageObject);
      }
      else {
        let alert = {
          messageId: generateMessageId(),
          content: docUploadRes.message,
          type: "text",
          from: "system",
          sentAt: new Date().toISOString(),
        };

        setRoom({
          ...room,
          ...{
            [selectedRoom]: {
              ...room[selectedRoom],
              ...{
                messages: {
                  ...room[selectedRoom].messages,
                  ...{ [alert.messageId]: alert },
                },
              },
            },
          },
        });
      }
    }
  };

  useEffect(() => {
    let timer;
    if (hideTicketCsat) {
      timer = setTimeout(() => {
        setHideTicketCsat(false);
        setTicketRatingDone(true);
      }, 6 * 60 * 1000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [hideTicketCsat]);


  const closeRoom = (message) => {
    let roomId = message.roomId;
    if (message.content && message.content !== "") {
      let data = JSON.parse(message.content);
      if (selectedRoom && roomId === selectedRoom) {
        setAskForRating(data.askForRating ? true : false);
        setAskForRatingTicket(data.askForRatingTicket ? true : false);
        // let agentName = room[selectedRoom].agent?.name
        // setHideTicketCsat(agentName ? true : false);
        // setTicketInactivityClosed(data.chatClosedBySystem)
      }
    }
    if (room[roomId]) {
      setRoom({
        ...room,
        ...{
          [roomId]: {
            ...room[roomId],
            ...{
              isOpen: false
            },
          },
        },
      });
    }
  };

  const setCsatDone = () => {
    setRoom({

      ...room,
      ...{
        [selectedRoom]: {
          ...room[selectedRoom],
          ...{ csatDone: true },
        },
      },

    });
  };

  const restartChat = async () => {
    setContactSupport(false)
    setHomeChat(false)
    if (selectedRoom && room[selectedRoom].isOpen) {
      let roomToken = room[selectedRoom].token
      setSelectedRoom(null)
      await api.closeRoom(roomToken, user.token)
    }
    let isMobile = await checkForMobileDevice();
    let data = await api.createRoom({
      userToken: user.token,
      url: URLData.params,
      isService: isService,
      productId: productId,
      policyDetail: inputType,
      skipVerifyingCarReg: skipVerifyingCarReg,
      carNoValid: carNoValid,
      carRegNo: carRegNo,
      isMobile: isMobile
    });
    
    if(data.maxUploadFileSize){
      setMaxUploadFileSize(parseInt(data.maxUploadFileSize))
    }
    if (data.webCallingEnable) {
      setWebCallingEnable(true);
    }
    setLoading(false)
    let roomData = data.roomData;
    let roomToken = data.roomToken

    if (data.isOffline) {
      setShowCarRegNoPage(false)
      setIsOffline(true)
      setOfflineMsg(data.offlineMsg)
      setTimeout(() => {
        window.parent.postMessage({ message: 'Chat Initiate Failed', chatInitiateFailed: true, minimize: true, closeChat: true }, '*');
      }, 2500);
    }
    else if (data.askForCarRegNo) {
      setShowCarRegNoPage(data.askForCarRegNo)
      setVerifyied(data.OPTVerified)
      setSales(true)
    }
    else if (data.contactSupport) {

      setContactSupport(data.contactSupport)
      setVerifyied(data.OPTVerified)
    }
    else if (data.isHome) {
      // Show homepage chat component
      //setVerifyied(true)
      console.log("This is homepage chat")
    }

    else if (roomData) {
      setSkipVerifyingCarReg(false)
      setShowCarRegNoPage(false)
      let roomData = data.roomData;
      setSelectedRoom(roomData.roomId)
      let roomToken = data.roomToken
      setHaveExistingChat(data.haveExistingChat)
      let messagesMap = {};

      if (data && data.messages && data.messages[roomData.roomId]) {

        for (const message of data.messages[roomData.roomId]) {
          messagesMap[message._id] = {
            messageId: message._id,
            content: message.content,
            from: message.from,
            roomId: message.roomId,
            sentAt: message.sentAt,
            type: message.type || MessageType.Text,
            selected: message.selected || null,
            role: message.role || null,
            receivedAt: message.receivedAt || null,
            deliveredAt: message.deliveredAt || null
          };
        }
      }

      if (roomData.agent && roomData.agent.name) {
        // Add agent assigned alert
        if (roomData.isHomePagechat || (roomData.transferredFrom?.depName !== "TermLife" && roomData.transferredFrom?.depName !== "Investments" && roomData.transferredFrom?.depName !== "Investments_Nri") && (roomData.department?.depName !== "TermLife" && roomData.department?.depName !== "Investments" && roomData.department?.depName !== "Investments_Nri")) {
          let alert = {
            messageId: generateMessageId(),
            alert: `You are now connected with ${roomData.agent.name} (${roomData.agent.employeeId})`,
            type: "alert",
            from: "system",
            sentAt: roomData.assignedAt,
          };
          if (roomData.roomTransfer && (roomData.transferredFrom?.depName === "Health" || roomData.transferredFrom?.depName === "Health_NRI") && roomData.productId === Product.Health) {
            alert["alert"] = `You have now been connected to a new advisor, ${roomData.agent.name} (${roomData.agent.employeeId}), to assist you better.`;
          }
          messagesMap[alert.messageId] = alert;
        }
      }
      // console.log(rm)
      setRoom({
        ...room,
        ...{
          [roomData.roomId]: {
            // ...rm[roomData.roomId],
            ...roomData,
            ...{
              messages: { ...messagesMap },
              token: roomToken,
            },
          },
        },
      });
      console.log("New Room initialized");
      let chatIntent = "";
      if (roomData.isService) {
        chatIntent = roomData.productName + "_service";
      } else {
        chatIntent = roomData.productName + "_sales";
      }
      GAEvent({
        eventAction: "chatInit", eventLabel: "Room created",
        custId: roomData.customerId, leadId: roomData.leadId, deptName: roomData.department.depName,
        chatMedium: roomData.chatMedium, roomId: roomData.roomId,
        source: roomData.source, chatintent: chatIntent
      })
      setMessageBuffer({
        ...messageBuffer,
        ...{
          [generateMessageId()]: {
            action: ChatEvents.JoinRoomRequested,
            auth: roomToken,
          },
          [generateMessageId()]: {
            action: ChatEvents.RequestBot,
            auth: roomToken,
          },
        },
      });
      if (data.isOfflineWorkingHour && data.offWorkingHourMsg) {
        setIsOfflineWorkingHour(true);
        setOffWorkingHourMsg(data.offWorkingHourMsg);
      }

      if(data.roomData.newTermUi){
        setNewTermUi(true);
      }
    }
  }
  const closeChat = async () => {
    console.log("closeChat")
    console.log(room[selectedRoom].token)
    if (room[selectedRoom].isOpen) {
      await api.closeRoom(room[selectedRoom].token, user.token)
    }
  }
  const updateMessage = (message) => {
    try {
      let roomId = message.roomId
      let content = JSON.parse(message.content)
      let existing = room[selectedRoom]?.messages[content.messageId];
      if (!existing) {
        existing = {};
      }
      setRoom({
        ...room,
        ...{
          [roomId]: {
            ...room[roomId],
            ...{
              agent: { name: content.name },
            },
            ...{
              messages: {
                ...room[roomId].messages,
                ...{
                  [content.messageId]: {
                    ...existing,
                    content: content.content,
                  },
                },
              },
            },
          },
        },
      });
    } catch (error) {
      console.error("Error updating message");
    }
  }

  const deleteMessage = (message) => {
    let messageId = message.messageId
    let roomId = message.roomId
    let msg = room.messages
    delete msg[messageId]
    if (room[roomId]) {
      setRoom({
        ...room,
        ...{
          [roomId]: {
            ...room[roomId],
            ...{
              message: { ...msg },
            },
          },
        },
      });
    }
  }

  const displayAllOptions = (messageId) => {
    let existing = room[selectedRoom].messages[messageId];
    if (!existing) {
      existing = {};
    }
    setRoom({
      ...room,
      ...{
        [selectedRoom]: {
          ...room[selectedRoom],
          ...{
            messages: {
              ...room[selectedRoom].messages,
              ...{
                [messageId]: {
                  ...existing,
                  displayAllOptions: true,
                },
                },
              },
            },
          },
        },
      });
  }
  const clearRoomData = () => {

    let roomData = room
    delete roomData[selectedRoom]
    setRoom({ roomData });
  }
  const BotAssigned = (botdetails) => {
    let roomId = botdetails.roomId
    if (room[roomId]) {
      let botInfo = JSON.parse(botdetails.content)
      setRoom({
        ...room,
        ...{
          [roomId]: {
            ...room[roomId],
            ...{
              bot: {
                botId: botInfo.id,
                botName: botInfo.name
              }
            },
          },
        }
      });
    }
  }
  const RemoveBot = (botdetails) => {
    console.log("remove bot")
    let roomId = botdetails.roomId
    if (room[roomId]) {
      setRoom({
        ...room,
        ...{
          [roomId]: {
            ...room[roomId],
            ...{
              bot: {
                botId: null,
                botName: null
              }
            },
          },
        }
      });
    }
  }
  const GAEvent = ({ eventAction, eventLabel, custId = "", leadId = "", deptName = "", chatMedium = "", roomId = "", source = "", chatintent = "", issueCode = "", subIssueCode = "" }) => {
    try{
      let chatType = room && room[selectedRoom] && room[selectedRoom].agent && room[selectedRoom].agent?.name ?'Agent':'Bot';
      let depName = room && room[selectedRoom] && room[selectedRoom].department && room[selectedRoom].department?.depName ? room[selectedRoom].department?.depName : deptName;
      let productId = room && room[selectedRoom] && room[selectedRoom].productId ? room[selectedRoom].productId : " "
      // let payload = {
      //   'event': eventAction,
      //   'ChatIntent':eventLabel,
      //   'customerID': room && room[selectedRoom] && room[selectedRoom].customerId ? room[selectedRoom].customerId : '',
      //   'ChatDepartmentName':depName,
      //   'ChatType':chatType,
      //   'productId': 10,
      //   'ChatRoomId': room && room[selectedRoom] ? selectedRoom : '',
      //   'document_name':''
      // }
      let productName = room && room[selectedRoom] && room[selectedRoom]?.productName ? room[selectedRoom].productName : ""
      let isService = room && room[selectedRoom] && room[selectedRoom].isService ? true : false
      let chatIntent = "";
      if (isService && productName) {
        chatIntent = productName + "_service"
      } else if (!isService && productName) {
        chatIntent = productName + "_sales"
      } else {
        chatIntent = chatintent
      }
      let payload = {
        'event': 'chat-event-tracking',
        'newchatevent': eventAction,
        'productId': 10,
        'CustomerID': room && room[selectedRoom] && room[selectedRoom].customerId ? room[selectedRoom].customerId : custId,
        'LeadID': room && room[selectedRoom] && room[selectedRoom].leadId ? room[selectedRoom].leadId : leadId,
        'chatintent': chatIntent,
        'chatdepartmentname': depName,
        'chattype': room && room[selectedRoom] && room[selectedRoom].source ? room[selectedRoom].source : source,
        'chatroomid': room && room[selectedRoom] ? selectedRoom : roomId,
        'chatMedium': room && room[selectedRoom] && room[selectedRoom].chatMedium ? room[selectedRoom].chatMedium : chatMedium,
        'eventLabel': eventLabel,
        'issueName': issueCode,
        'subissueName': subIssueCode
      }
      //console.log("GA SENT ##################",payload)
      window.dataLayer.push(payload)
    }catch(e){
      console.log('GAEVENT LOG : ', e.message)
    }
  }

  const closeComparision = (messageId) => {
    setPlanComaprisonDetails(null)
  }

  const showPlansComparison = (messageId) => {
    console.log(messageId)
    setPlanComaprisonDetails(room[selectedRoom]["messages"][messageId])
  }
  const closePlanFeaturePopup = (messageId) => {
    setPlanFeatures(null)
  }

  const ShowPlanFeatures = (messageId) => {
    console.log(messageId)
    setPlanFeatures(room[selectedRoom]["messages"][messageId])
  }
  const setRoomview = (roomToken) => {
    setMessageBuffer({
      ...messageBuffer,
      ...{
        [generateMessageId()]: {
          action: ChatEvents.SetRoomProperties,
          properties: JSON.stringify({
            chatView: true
          }),
          auth: roomToken,
        },
      },
    });
  }

  const regenDoc = async (documentId) => {
    let roomToken = room && room[selectedRoom] ? room[selectedRoom].token : null
    let docId = {
      docId: documentId
    };
    const regnDocRes = await api.reGenDocument(JSON.stringify(docId), roomToken)
    if (regnDocRes.result) {
      window.open(regnDocRes.result.ttlDocUrl, '_blank');
    }
    else {
      alert("Error in file opening")
    }
  }
  const customerFeedback = (option, feedback) => {
    let roomToken = room && room[selectedRoom] ? room[selectedRoom].token : null
    api.updateCustomerFeedback(roomToken, option, feedback);
  }

  const customerQueryResolutionFeedback = (status) => {
    let roomToken = room && room[selectedRoom] ? room[selectedRoom].token : null
    api.updateCustomerTicketFeedback(roomToken, status);
  }
  const serviceAgentFeedback = async (option) => {
    let roomToken = room && room[selectedRoom] ? room[selectedRoom].token : null
    let resp = await api.agentServiceCsatFeedback(roomToken, option);
    return resp
  }
  const onSetRoomProperties = (message) => {
    if (message.roomId == selectedRoom) {
      let properties = JSON.parse(message.properties)

      if (properties.productId) {
        setRoom({
          ...room,
          ...{
            [selectedRoom]: {
              ...room[selectedRoom],
              ...{
                productId: properties.productId
              }
            }
          },
        });
      }

    }
  };
  const onCallInitialized = (message, roomToken) => {
    if (message.content) {
      // let content = JSON.parse(message.content);
      // let alertMessage = {
      //   messageId: generateMessageId(),
      //   alert: `You are now on Call with ${content.name} (${content.employeeId})`,
      //   type: "alert",
      //   from: "system",
      //   sentAt: new Date(content.callInitiatedAt).toISOString()
      // };


      // setRoom({
      //   ...room,
      //   ...{
      //     [message.roomId]: {
      //       ...room[message.roomId],
      //       ...{
      //         agent: { name: content.name, employeeId: content.employeeId },
      //       },
      //       ...{
      //         messages: {
      //           ...room[message.roomId].messages,
      //           ...{ [alertMessage.messageId]: alertMessage },
      //         },
      //       },
      //     },
      //   },
      // });

      setMessageBuffer({
        ...messageBuffer,
        ...{
          [generateMessageId()]: {
            action: WebCalling.CallInitiated,
            messageId: message.messageId,
            content: message.content,
            auth: roomToken
          },
        },
      });
    }
  };

  const onCallDisconnect = (message, roomToken) => {
    if (message.content) {
      let content = JSON.parse(message.content);
      let alertMessage = {
        messageId: generateMessageId(),
        alert: 'Call Disconnected',
        type: "alert",
        from: "system",
        sentAt: new Date(content.callDisconnectedAt).toISOString(),
      };


      setRoom((prevRoom) => ({
        ...prevRoom,
        [selectedRoom]: {
          ...prevRoom[selectedRoom],
          messages: {
            ...prevRoom[selectedRoom].messages,
            [alertMessage.messageId]: alertMessage,
          },
        },
      }));

      setMessageBuffer({
        ...messageBuffer,
        ...{
          [generateMessageId()]: {
            action: WebCalling.CallEnded,
            messageId: webCallIdRef.current,
            content: message.content,
            auth: roomToken
          },
        },
      });
    }

  };
  const onCallProcessing = (message, roomToken) => {
    if (message.content) {

      setMessageBuffer({
        ...messageBuffer,
        ...{
          [generateMessageId()]: {
            action: WebCalling.CallInProcessing,
            messageId: webCallIdRef.current,
            content: message.content,
            auth: roomToken
          },
        },
      });
    }

  };

  const onVCButtonVisibility = (message) => {
    console.log("onVCButtonVisibility", message)
    let roomId = message.roomId;
    if (message.content && message.content !== "") {
      let data = JSON.parse(message.content);
      if (room[roomId]) {
        if (data.showVideoCallButton) {
          window.parent.postMessage({ message: 'Video Call Button Visible', source: 'Chat', vcButtonVisible: true, agentId: room[selectedRoom].agent.employeeId }, '*');
        }
        setRoom({
          ...room,
          ...{
            [roomId]: {
              ...room[roomId],
              ...{
                showVCButton: data.showVideoCallButton
              },
            },
          },
        });
      }

    }
  };

  return initialized ? (
    <>
      <ChatConnection
        setInitialized={setInitialized}
        connected={connected}
        setConnected={setConnected}
        registered={registered}
        setRegistered={setRegistered}
        user={user}
        room={room}
        onJoinRoom={onJoinRoom}
        onMessage={onMessage}
        onReceiveReceipt={onReceiveReceipt}
        messageBuffer={messageBuffer}
        setMessageBuffer={setMessageBuffer}
        onAssignAgent={onAssignAgent}
        closeRoom={closeRoom}
        roomToken={room.token || null}
        updateMessage={updateMessage}
        deleteMessage={deleteMessage}
        AssignmentRequested={AssignmentRequested}
        BotAssigned={BotAssigned}
        onDeliveryReceipt={onDeliveryReceipt}
        onReadReceipt={onReadReceipt}
        RemoveBot={RemoveBot}
        onSetRoomProperties={onSetRoomProperties}
        onVCButtonVisibility={onVCButtonVisibility}
      ></ChatConnection>
      {isOffline ?
        <OffllineMessage offlineMsg={OfflineMessage} >
        </OffllineMessage>
        :
        <>
          {styleInit ?
            <HomePage
              getHistoryMessages={getHistoryMessages}
              GAEvent={GAEvent}
              botName={room && room[selectedRoom] && room[selectedRoom].bot ? room[selectedRoom].bot.botName : null}
              sendMessage={sendMessage}
              sendEvent={sendEvent}
              messages={room && room[selectedRoom] && room[selectedRoom].messages ? room[selectedRoom].messages : []}
              oldMessages={room && room[selectedRoom] && room[selectedRoom].oldMessages ? room[selectedRoom].oldMessages : []}
              userId={user.id}
              agentName={room && room[selectedRoom] && room[selectedRoom].agent ? room[selectedRoom].agent.name : null}
              empId={room && room[selectedRoom] && room[selectedRoom].agent ? room[selectedRoom].agent.employeeId : null}
              uploadFile={uploadFile}
              welcomeMsg={room.welcomeMessage}
              roomClosed={room && room[selectedRoom] && room[selectedRoom].isOpen ? false : true}
              csatDone={room && room[selectedRoom] && room[selectedRoom].csatDone ? true : false}
              setCsatDone={setCsatDone}
              roomId={selectedRoom}
              roomToken={room && room[selectedRoom] ? room[selectedRoom].token : null}
              isOffline={room && room[selectedRoom] && room[selectedRoom].isOffline ? room[selectedRoom].isOffline : false}
              restartChat={restartChat}
              closeChat={closeChat}
              messageCounter={messageCounter}
              offlineMsg={room && room[selectedRoom] ? room[selectedRoom].offlineMsg : null}
              displayAllOptions={displayAllOptions}
              clearRoomData={clearRoomData}
              showPlansComparison={showPlansComparison}
              closeComparision={closeComparision}
              planComparison={planComparison}
              productId={room[selectedRoom] ? room[selectedRoom].productId : null}
              regenDoc={regenDoc}
              customerFeedback={customerFeedback}
              customerQueryResolutionFeedback={customerQueryResolutionFeedback}
              planFeatures={planFeatures}
              closePlanFeaturePopup={closePlanFeaturePopup}
              ShowPlanFeatures={ShowPlanFeatures}
              setRoomview={setRoomview}
              chatView={room && room[selectedRoom] && room[selectedRoom].chatView ? room[selectedRoom].chatView : null}
              isService={room && room[selectedRoom] && room[selectedRoom].isService ? room[selectedRoom].isService : null}
              serviceAgentFeedback={serviceAgentFeedback}
              lastHistoryMsg={lastHistoryMsg}
              showHistory={showHistory}
              haveExistingChat={haveExistingChat}
              setHaveExistingChat={setHaveExistingChat}
              source={room && room[selectedRoom] && room[selectedRoom].source ? room[selectedRoom].source : null}
              isOfflineWorkingHour={isOfflineWorkingHour}
              offWorkingHourMsg={offWorkingHourMsg}
              askForRating={askForRating}
              setTabHasFocus={setTabHasFocus}
              loader={loader}
              chatDivRef={chatDivRef}
              newTermUi={newTermUi}
              onCallInitialized ={onCallInitialized}
              onCallDisconnect ={onCallDisconnect}
              onCallProcessing={onCallProcessing}
              webCallIdRef={webCallIdRef}
              webCallingEnable={webCallingEnable}
              askForRatingTicket={askForRatingTicket}
              ticketRatingDone={ticketRatingDone}
              ticketInactivityClosed={ticketInactivityClosed}
              showVideoCallButton={room && room[selectedRoom] ? room[selectedRoom].showVCButton : false}
              agentMsgReplied={agentMsgReplied}
              setAgentMsgReplied={setAgentMsgReplied}
              customerName={room && room[selectedRoom] && room[selectedRoom].user && room[selectedRoom].user.name ? room[selectedRoom].user.name : null}
              totalMsgs={room && room[selectedRoom] && room[selectedRoom].messages ? Object.keys(room[selectedRoom].messages).length : 0}
            />

            : <LoadingScreen HealthMobileView={checkIfHealthMobileView} />}
        </>
      }
      {contactSupport && styleInit ? <ContactSupport
        inputType={inputType}
        setInputType={setInputType}
        userToken={user.token}
        setInitialized={setInitialized}
        setConnected={setConnected}
        setRegistered={setRegistered}
        isService={isService}
        setService={setService}
        OPTVerified={OPTVerified}
        setVerifyied={setVerifyied}
        productId={productId}
        selectProductId={selectProductId}
        isSales={isSales} setSales={setSales}
        restartChat={restartChat}
        maskedMobileNo={maskedMobileNo}
        setMaskedMobileNo={setMaskedMobileNo}
        verifyOTP={verifyOTP}
        setVerifyOTP={setVerifyOTP}

      /> : null}
      {showCarRegNoPage && styleInit ?
        <CarRegNumberPage
          isSales={isSales}
          skipVerifyingCarReg={skipVerifyingCarReg}
          setSkipVerifyingCarReg={setSkipVerifyingCarReg}
          restartChat={restartChat}
          OPTVerified={OPTVerified}
          carRegNo={carRegNo}
          setCarRegNo={setCarRegNo}
          carNoValid={carNoValid}
          setCarNoValid={setCarNoValid}
          loading={loading}
          setLoading = {setLoading}
        /> : null}

        {homeChat && styleInit ?
          <>
          <PbWebChat
            inputType={inputType}
            setInputType={setInputType}
            userToken={user.token}
            setInitialized={setInitialized}
            setConnected={setConnected}
            setRegistered={setRegistered}
            isService={isService}
            setService={setService}
            OPTVerified={OPTVerified}
            setVerifyied={setVerifyied}
            productId={productId}
            selectProductId={selectProductId}
            isSales={isSales} setSales={setSales}
            restartChat={restartChat}
            maskedMobileNo={maskedMobileNo}
            setMaskedMobileNo={setMaskedMobileNo}
            verifyOTP={verifyOTP}
            setVerifyOTP={setVerifyOTP}

          />
          </>:null}
    </>
  ) : (
    <LoadingScreen />
  );
}

export default App;
